"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddOnPriceCalculationInformation = getAddOnPriceCalculationInformation;
const constants_1 = require("../constants/constants");
const copy_1 = __importDefault(require("../constants/copy"));
function getAddOnPriceCalculationInformation({ priceByDay, priceByGuest, quantity, }) {
    const isPricePerDayAndGuest = priceByDay === constants_1.PER_DAY && priceByGuest === constants_1.PER_GUEST;
    const isPricePerDay = priceByDay === constants_1.PER_DAY && priceByGuest === constants_1.SET_GUEST;
    const isPricePerGuest = priceByDay === constants_1.SET_DAY && priceByGuest === constants_1.PER_GUEST;
    if (isPricePerDayAndGuest && quantity > 1) {
        return copy_1.default.perGuestPerDayInfo;
    }
    if (isPricePerDay && quantity > 1) {
        return copy_1.default.perDayInfo;
    }
    if (isPricePerGuest && quantity > 1) {
        return copy_1.default.perGuestInfo;
    }
    return "";
}
